const PokemonActionTypes = {
    GET_ALL_POKEMON_START: "GET_ALL_POKEMON_START",
    GET_ALL_POKEMON_SUCCESS: "GET_ALL_POKEMON_SUCCESS",
    GET_ALL_POKEMON_FAILURE: "GET_ALL_POKEMON_FAILURE",

    DISPLAY_CARD: "DISPLAY_CARD",
    DISPLAY_BUTTON: "DISPLAY_BUTTON",

    GET_INDIVIDUAL_POKEMON_START: "GET_INDIVIDUAL_POKEMON_START",
    GET_INDIVIDUAL_POKEMON_SUCCESS: "GET_INDIVIDUAL_POKEMON_SUCCESS",
    GET_INDIVIDUAL_POKEMON_FAILURE: "GET_INDIVIDUAL_POKEMON_FAILURE",

    SAVE_INDIVIDUAL_POKEMON: "SAVE_INDIVIDUAL_POKEMON",
}

export default PokemonActionTypes;